import client from './api-client'

const storeProfileInfo = (data) => {
    return client.post(`account/me`, data)
}
export {
    storeProfileInfo,
}
